import { Component, computed, input, output, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { ErrorSnackBarData } from '@r1-compass-library/models';

@Component({
    selector: 'r1-compass-lib-http-error-base',
    template: `
        <div class="error-handling-snack-bar-container">
            @if (data().statusCode) {
                <div class="error-handling-snack-bar-message-container">
                    {{ data().statusCode }}
                    @if (data().statusText) {
                        - {{ data().statusText }}
                    }
                </div>
            }
            @for (message of data().messages; track $index) {
                <div class="error-handling-snack-bar-message-container">
                    {{ message }}
                </div>
            }
            @if (data().showDismissButton) {
                <button mat-flat-button class="button-white" (click)="dismiss.emit()" type="button">Dismiss</button>
            }
        </div>
        <div class="error-handling-snack-bar-container-expanded">
            @if (data().showExpandButton) {
                <span id="expansion-btn">
                    <button mat-flat-button class="button-white" (click)="onExpand()" type="button">
                        {{ !showExpanded ? 'Show More' : 'Show Less' }}
                    </button>
                </span>

                @if (showExpanded) {
                    @for (message of data().expandMessages; track $index) {
                        <div class="error-handling-snack-bar-message-container">
                            {{ message }}
                        </div>
                    }
                }
            }
        </div>
    `,
    styleUrls: ['./http-error-base.component.scss'],
    imports: [MatButtonModule],
    encapsulation: ViewEncapsulation.None,
    host: {
        '[class.show-embedded-view]': 'showEmbeddedView()',
    },
})
export class HttpErrorBaseComponent {
    showExpanded = false;

    data = input.required<ErrorSnackBarData>();

    /**
     * @description Determines if this component should be styled for embed and not snackbar
     */
    showEmbeddedView = computed(() => !this.data().showDismissButton);

    dismiss = output<void>();

    onExpand(): void {
        this.showExpanded = !this.showExpanded;
    }
}
